import { IMembership } from 'pac-api';
import { Association } from './assoication';

export class MembershipModel implements IMembership {
  public mbr_key: string = undefined;
  public mbr_cst_key: string = undefined;
  public mbr_asn_code: Association = undefined;
  public mbr_join_date: Date = undefined;
  public mbr_rejoin_date: Date = undefined;
  public mbr_renew_date: Date = undefined;
  public mbr_expire_date: Date = undefined;
  public mbr_terminate_date: Date = undefined;
  public mbr_invoice_date: Date = undefined;
  public mbr_insured_start_date_dn_ext: Date = undefined;
  public mbr_insured_expire_date_dn_ext: Date = undefined;
  public mbr_membership_agreement_flag_dn_ext: boolean = undefined;
  public mbr_p02_key_ext: string = undefined;
  public mbs_code: string = undefined;
  public mbt_key: string = undefined;
  public mbt_code: string = undefined;
  public mbt_flip_customer_member_flag: boolean = undefined;
  public mbt_includes_insurance_flag_ext: boolean = undefined;
  public mbr_auto_pay: boolean = undefined;
  public mbr_pak_prd_key: string = undefined;

  public mbr_do_not_renew_flag: boolean = false;
  public mbr_installment_payments_flag: boolean = false;
  public mbr_num_of_installments_for_renewal: number = undefined;
  public mbr_cpi_key: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            case 'mbr_join_date':
            case 'mbr_rejoin_date':
            case 'mbr_renew_date':
            case 'mbr_expire_date':
            case 'mbr_terminate_date':
            case 'mbr_invoice_date':
            case 'mbr_insured_start_date_dn_ext':
            case 'mbr_insured_expire_date_dn_ext':
              var k: 'mbr_join_date' | 'mbr_rejoin_date' | 'mbr_renew_date' | 'mbr_expire_date' | 'mbr_terminate_date' | 'mbr_invoice_date' | 'mbr_insured_start_date_dn_ext' | 'mbr_insured_expire_date_dn_ext' = <any>key;
              if (source[k] == null || source[k] == undefined || source[k] == '') {
                this[k] = null;
              } else {
                this[k] = new Date(source[k]);
              }
            break;
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }

}
